"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var props_1 = require("../context/props");
var form_1 = require("../context/form");
var useValidateForm_1 = __importDefault(require("./useValidateForm"));
var useForm_1 = __importDefault(require("./useForm"));
var useOnOk = function () {
    var onSubmitForm = (0, props_1.usePropsContext)().onSubmitForm;
    var validateForm = (0, useValidateForm_1.default)();
    var setErrors = (0, form_1.useFormContext)().setErrors;
    var form = (0, useForm_1.default)();
    var onOk = (0, react_1.useCallback)(function (event) {
        event.preventDefault();
        var errors = validateForm();
        if (!Object.keys(errors).length) {
            onSubmitForm(form);
        }
        setErrors(errors);
    }, [
        onSubmitForm,
        validateForm,
        setErrors,
        form
    ]);
    return onOk;
};
exports.default = useOnOk;
